document.addEventListener("DOMContentLoaded", () => {
    console.log(9784);
    const keysToDelete = [
        'lastCustomVariantId',
        'lastCustomProductId',
        'imageUrl',
        'imageUrlPlan',
        'imageUrlFront',
        'typeProduct',
        'colorProduct',
        'countProduct',
        'lengthWorktop',
        'widthWorktop',
        'rearSize',
        'allInfoSides',
        'holesAllHide',
        'countPool',
        'dataPool1',
        'dataPool2',
        'dataPool3',
        'countHoles',
        'countTowel',
        'poles',
        'towel1',
        'towel2',
        'towel3',
        'supportPolesIncluded'
      ];
      
keysToDelete.forEach(key => {
  localStorage.removeItem(key);
});
})